import { render, staticRenderFns } from "./Evento_deporte_prematch2.vue?vue&type=template&id=c6413170&scoped=true&"
import script from "./Evento_deporte_prematch2.vue?vue&type=script&lang=js&"
export * from "./Evento_deporte_prematch2.vue?vue&type=script&lang=js&"
import style0 from "./Evento_deporte_prematch2.vue?vue&type=style&index=0&id=c6413170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6413170",
  null
  
)

export default component.exports